import { selector } from "recoil";

import intersectIndiciesState from "./intersectIndicesState";

// how many blocks above and below intersected elements we show
const VISIBLE_RESERVE = 3;

export default selector({
  key: "visibleIndicesSelector",
  get: ({ get }) => {
    const intersected = get(intersectIndiciesState);
    if (!intersected?.length) return [];
    const min = Math.min(...intersected);
    const max = Math.max(...intersected);
    return arrayRange(min - VISIBLE_RESERVE, max + VISIBLE_RESERVE);
  },
});

export const arrayRange = (from: number, to: number) => {
  return [...Array(to - from + 1).keys()].map((x) => x + from);
};
